import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/service/snackbar.service';
import { CalendarClass } from '../class/calendar-class';
import { CalendarClassService } from '../services/calendar-class.service';
import { CalendarClassFormComponent } from '../calendar-class-form/calendar-class-form.component';
import { ConfirmDialogComponent } from '../../../../shared/confirm-dialog/confirm-dialog.component';
import { LayoutService } from 'src/app/service/layout.service';
import { colorArray } from '../components/mkg-calendar/colors';

@Component({
  selector: 'app-calendar-class-list',
  templateUrl: './calendar-class-list.component.html',
  styleUrls: ['./calendar-class-list.component.scss']
})
export class CalendarClassListComponent implements OnInit {

  private _layoutService = inject(LayoutService);

  calendarClasses: CalendarClass[] = [];
  displayedColumns: string[] = ['color', 'description', 'actions'];
  isLoading = true;

  constructor(
    private calendarClassService: CalendarClassService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this._layoutService.component = "calendar-class";
    this.loadCalendarClasses();
    this._layoutService.loader = false;

  }

  loadCalendarClasses(): void {
    this.isLoading = true;
    this.calendarClassService.getAll().subscribe({
      next: (classes) => {
        this.calendarClasses = classes;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.snackbarService.error('Erro ao carregar tipos de agendamento');
        console.error(error);
      }
    });
  }

  openForm(calendarClass?: CalendarClass): void {
    const dialogRef = this.dialog.open(CalendarClassFormComponent, {
      width: '500px',
      data: calendarClass ? { ...calendarClass } : new CalendarClass()
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadCalendarClasses();
      }
    });
  }

  deleteCalendarClass(calendarClass: CalendarClass): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Confirmar exclusão',
        message: `Deseja realmente excluir o tipo de agendamento "${calendarClass.description}"?`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && calendarClass._id) {
        this.calendarClassService.delete(calendarClass._id).subscribe({
          next: () => {
            this.snackbarService.success('CALENDAR_CLASS.DELETED'),
            this.loadCalendarClasses();
          },
          error: (error) => {
            this.snackbarService.error('CALENDAR_CLASS.NOT_DELETED', error),
            console.error(error);
          }
        });
      }
    });
  }
  getColorSecondary(primaryColor: string): string {
    const colorSet = colorArray.find(c => c.primary === primaryColor);
    return colorSet ? colorSet.secondary : '#f5f5f5';
  }

  getColorDarker(primaryColor: string): string {
    const colorSet = colorArray.find(c => c.primary === primaryColor);
    return colorSet ? colorSet.darker : primaryColor;
  }
}
